import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { UserData } from '../model/user-data';
import { UsersDataResponse } from '../model/users-data-response';

@Component({
    selector: 'app-adminstration',
    templateUrl: './adminstration.component.html',
    styleUrls: ['./adminstration.component.scss'],
    standalone: false
})
export class AdminstrationComponent implements OnInit {
  user: UsersDataResponse;
  userData: UserData;
  navLinks: any[];
  activeLinkIndex = -1;
  activeLink: any;
  background = '';
  userAction= '';
  dcList = [

    {
      label: 'Users List',
      path: './dc-users',
      index: 0
    },
    {
      label: 'DC Maintenance',
      path: './dc-maintainence',
      index: 1
    }
      
  ];
  dcUserEditList = [

    {
      label: 'Users List',
      path: './add-edit-dc-user',
      index: 0
    },
    {
      label: 'DC Maintenance',
      path: './dc-maintainence',
      index: 1
    }
    
  
  ];
  dcEditList = [

    {
      label: 'Users List',
      path: './dc-users',
      index: 0
    },
    {
      label: 'DC Maintenance',
      path: './edit-dc',
      index: 1
    }
    
  
  ];

 

  constructor(private route: ActivatedRoute,
    private router: Router, private userservice: UserService) {
      this.route.queryParams
      .subscribe(params => {
       this.userAction = params['action'];
    this.userservice.getCurrentUser().subscribe(data => {
      this.user = data;
      this.userData = data.userData;
      if(this.userAction===undefined){
        this.navLinks=this.dcList;
        }else
      if(this.userAction==='dc-user-edit' || this.userAction==='dc-user-add'){
      this.navLinks=this.dcUserEditList;
      }else
      if(this.userAction==='dc-edit'){
        this.navLinks=this.dcEditList;
      }


    })

  })


  }
  ngOnInit(): void {
    this.router.events.subscribe((res) => {
      this.activeLinkIndex = this.navLinks.indexOf(this.navLinks.find(tab => tab.path === '.' + this.router.url));
    });


  }




}
